import { render, staticRenderFns } from "./surveyJobListRedirect.vue?vue&type=template&id=854de856"
import script from "./surveyJobListRedirect.vue?vue&type=script&lang=js"
export * from "./surveyJobListRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports